<template>
  <div>
    <template>
      <CContainer>
        <CModal
          title="Confirmar que quieres eliminar el quiz  quizSelected"
          color="danger"
          :show.sync="confirmar"
          class="text-center"
          style="top: 40px"
          @close="confirmar = false"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">
              Confirmar que quieres eliminar el quiz {{ quizSelected.name }}
            </p>
          </mdbModalHeader>
          <mdbModalFooter center slot="footer">
            <CButton outline="danger" @click="eliminar()">Si</CButton>
            <CButton color="danger" @click="confirmar = false">No</CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>
    </template>
    <template>
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalNombre"
          class="text-center"
          style="max-height: 90vh"
          @close="modalNombre = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>

          <div class="row text-left">
            <div class="col-md-12">
              <!-- <label class="typo__label">Nombre</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="nombre"
                required
                invalidFeedback="Coloca el Nombre"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Nombre
                </span>
              </mdb-input>
            </div>
            <div class="col-md-12">
              <!-- <label class="typo__label">Store Code</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="store_code"
                required
                invalidFeedback="Coloca el store code"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Store Code
                </span>
              </mdb-input>
            </div>
          </div>
          <div center slot="footer">
            <mdb-btn color="secondary" @click.native="modalNombre = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="setNombre"
              :disabled="isLoadingnombre"
            >
              <span v-if="!isLoadingnombre">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingnombre"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>

      <!-- modalTelefono:false,
      modalTelefonoadicional:false,
      modalCategoriaprincipal:false,
      modalCategoriasadicionales:false,
      modalHorario:false,
      modalHorarioespecial:false,
      modalDescripcion:false,
      modalAnadiratributo:false,
      modalAnadirservicio :false, -->
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalDirection"
          class="text-center"
          @close="modalDirection = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>

          <div class="row text-left">
            <div class="col-md-12">
              <!-- <label class="typo__label">Nombre</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="region"
                required
                invalidFeedback="Coloca el Region"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Region
                </span>
              </mdb-input>
            </div>
            <div class="col-md-12">
              <!-- <label class="typo__label">Store Code</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="postal"
                required
                invalidFeedback="Coloca el Codigo Postal "
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Codigo Postal
                </span>
              </mdb-input>
            </div>
            <div class="col-md-12">
              <!-- <label class="typo__label">Store Code</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="area_admin"
                required
                invalidFeedback="Coloca el Area Administrativa"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Area Administrativa
                </span>
              </mdb-input>
            </div>
            <div class="col-md-12">
              <!-- <label class="typo__label">Store Code</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="localidad"
                required
                invalidFeedback="Coloca el Localidad"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Localidad</span
                >
              </mdb-input>
            </div>
            <div class="col-md-12">
              <!-- <label class="typo__label">Store Code</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="direction"
                required
                invalidFeedback="Coloca el Dirección"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Dirección</span
                >
              </mdb-input>
            </div>
          </div>
          <div center slot="footer">
            <mdb-btn color="secondary" @click.native="modalDirection = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="setDirection"
              :disabled="isLoadingnombre"
            >
              <span v-if="!isLoadingDirection">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingDirection"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalTelefono"
          class="text-center"
          style="max-height: 90vh"
          @close="modalTelefono = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>

          <div class="row text-left">
            <div class="col-md-12">
              <!-- <label class="typo__label">Nombre</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="telefono"
                required
                invalidFeedback="Coloca el Teléfono"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Teléfono
                </span>
              </mdb-input>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-12">
              <!-- <label class="typo__label">Nombre</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="telefono_add"
                invalidFeedback="Coloca el Teléfono adicional"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Teléfonos adicionales</span
                >
              </mdb-input>
            </div>
          </div>
          <div center slot="footer">
            <mdb-btn color="secondary" @click.native="modalTelefono = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="setTelephone"
              :disabled="isLoadingTelefono"
            >
              <span v-if="!isLoadingTelefono">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingTelefono"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalCategoriaprincipal"
          class="text-center"
          style="max-height: 90vh"
          @close="modalCategoriaprincipal = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>
          <div class="form-group">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="categoriaPrincipal"
                />
                <label class="form-checl-lable"><strong>Categoria principal</strong></label>
              </div>
          <div class="row text-left">
            <div class="col-md-12">
              <!-- <label class="typo__label">Nombre</label> -->
              <!-- <mdb-input
                  class="mb-3 mt-0"
                  v-model="gCategories"
                  required
                  invalidFeedback="Coloca el Google Categories"
                > -->
              <label class="typo__label font-weight-bold"
                >Google Categories</label
              >
              <multiselect
                v-model="selected_categories"
                placeholder="Seleccione un Category"
                label="name"
                track-by="category_id"
                :options="location_categories"
                :close-on-select="true"
                :clear-on-select="false"
                :multiple="false"
                :taggable="false"
              ></multiselect>
              <!-- <span class="input-group-text md-addon" slot="prepend">Google Categories</span> -->
              <!-- </mdb-input> -->
            </div>
          </div>
          <div center slot="footer">
            <mdb-btn
              color="secondary"
              @click.native="modalCategoriaprincipal = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="updateLocationCategories"
              :disabled="isLoadingCategoriaprincipal"
            >
              <span v-if="!isLoadingCategoriaprincipal">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingCategoriaprincipal"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalDescripcion"
          class="text-center"
          style="max-height: 90vh"
          @close="modalDescripcion = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>

          <div class="row text-left">
            <div class="col-md-12">
              <!-- <label class="typo__label">Nombre</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="description"
                required
                invalidFeedback="Coloca el Description"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Description</span
                >
              </mdb-input>
            </div>
          </div>
          <div center slot="footer">
            <mdb-btn color="secondary" @click.native="modalDescripcion = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="updatelocationDescription"
              :disabled="isLoadingDescripcion"
            >
              <span v-if="!isLoadingDescripcion">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingDescripcion"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalAnadiratributo"
          class="text-center"
          style="max-height: 90vh"
          @close="modalAnadiratributo = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>

          <div class="row text-left">
            <!--  <div class="col-md-12">
                 <label class="typo__label  font-weight-bold">Google Attribute</label>
                    <multiselect
                    v-model="actualAttributeSelected"
                    placeholder="Seleccione un Partner"
                    label="attribute_id"
                    track-by="id"
                    :options="actualAttribute"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :multiple="false"
                    :taggable="false"
                    @input="getPossibleLocationAttributes"
                    ></multiselect>
              </div>-->

            <div class="col-md-12">
              <label class="typo__label font-weight-bold"
                >Possible Attribute
              </label>
              <multiselect
                v-model="possibleAttributeSelected"
                placeholder="Seleccione un Partner"
                label="name"
                track-by="id"
                :options="possibleAttribute"
                :close-on-select="true"
                :clear-on-select="false"
                :multiple="false"
                :taggable="false"
                @input="getPossibleAttributevalue"
              ></multiselect>
            </div>
            <div class="col-md-12 mt-3" v-if="possibleAttributeSelected">
              <div v-if="possibleAttributeSelected.value_type === 'BOOL'">
                <toggle-button
                  model="google_attribute_bool"
                  color="green"
                  :labels="{ checked: 'Yes', unchecked: 'No' }"
                  @change="onChangeEventHandler"
                />
              </div>

              <div v-if="possibleAttributeSelected.value_type === 'URL'">
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="google_attribute_url"
                  required
                  invalidFeedback="Coloca el Localidad"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >URL</span
                  >
                </mdb-input>
              </div>

              <div
                v-if="possibleAttributeSelected.value_type === 'REPEATED_ENUM'"
              >
                <!-- <label class="typo__label  font-weight-bold">Possible Attribute Value</label> -->
                <label class="typo__label font-weight-bold"
                  >Google Attribute
                </label>
                <multiselect
                  v-model="possibleAttributeValueSelected"
                  placeholder="Seleccione un Partner"
                  label="value"
                  track-by="id"
                  :options="possibleAttributeValues"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :multiple="true"
                  :taggable="true"
                ></multiselect>
              </div>
            </div>
          </div>
          <div center slot="footer">
            <mdb-btn
              color="secondary"
              @click.native="modalAnadiratributo = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="updateGoogleAttribute"
              :disabled="isLoadingAnadiratributo"
            >
              <span v-if="!isLoadingAnadiratributo">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingAnadiratributo"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalHorarioespecial"
          class="text-center"
          style="max-height: 90vh"
          @close="modalHorarioespecial = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <div class="form-group">
                <label><strong>Dia de Apertura</strong></label>
                <datetime
                  type="date"
                  input-id="fecha-input"
                  format="yyyy-MM-dd"
                  v-model="start_date"
                ></datetime>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label><strong>Dia de Cierre</strong></label>
                <datetime
                  type="date"
                  input-id="fechafin-input"
                  format="yyyy-MM-dd"
                  v-model="end_date"
                ></datetime>
              </div>
            </div>
            <div class="col-md-6 ml-4">
              <!-- <input type="checkbox" 
                  :value="cerrado"
                  > -->

              <div class="form-group">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="cerrado"
                />
                <label class="form-checl-lable"><strong>Cerrado</strong></label>
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>
            <div v-if="!cerrado">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="typo__label"
                    ><strong>Hora de Apertura : &nbsp;&nbsp; </strong></label
                  >
                  <!-- <mdb-input
                      class="mb-3 mt-0"
                      v-model="hApertura"
                      required
                      invalidFeedback="Coloca el Nombre"
                    > -->
                  <vue-timepicker
                    v-model="hApertura"
                    format="HH:mm"
                  ></vue-timepicker>
                </div>
                <!-- <span class="input-group-text md-addon" slot="prepend">Hora de Apertura</span> -->
                <!-- </mdb-input> -->
              </div>
              <div class="col-md-12">
                <!-- <label class="typo__label">Nombre</label> -->
                <!-- <mdb-input
                  class="mb-3 mt-0"
                  v-model="hClausura"
                  required
                  invalidFeedback="Coloca el Nombre"
                > -->
                <div class="form-group">
                  <label class="typo__label"
                    ><strong>Hora de Clausura : &nbsp;&nbsp; </strong>
                  </label>
                  <vue-timepicker
                    v-model="hClausura"
                    format="HH:mm"
                  ></vue-timepicker>
                </div>
                <!-- <span class="input-group-text md-addon" slot="prepend">Hora de Clausura</span> -->
                <!-- </mdb-input> -->
              </div>
            </div>
          </div>

          <div center slot="footer">
            <mdb-btn
              color="secondary"
              @click.native="modalHorarioespecial = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="updateLocationSplSchedule"
              :disabled="isLoadingHorarioespecial"
            >
              <span v-if="!isLoadingHorarioespecial">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingHorarioespecial"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalHorario"
          class="text-center"
          style="max-height: 90vh"
          @close="modalHorario = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>
          <div class="row text-left">
            <div class="col-md-6 pl-3">
              <label class="form-checl-lable"><strong>Lunes</strong></label>
              <div class="form-group">
                <label class="form-checl-lable">Albierto</label>
                <input
                  type="checkbox"
                  class="form-check-input ml-4"
                  v-model="lunes"
                />
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>
            <div class="col-md-6">
              <label class="form-checl-lable"><strong>Martes</strong></label>
              <div class="form-group">
                <label class="form-checl-lable">Albierto</label>
                <input
                  type="checkbox"
                  class="form-check-input ml-4"
                  v-model="martes"
                />
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>

            <div class="col-md-6 pl-3">
              <label class="form-checl-lable"><strong>Miercoles</strong></label>
              <div class="form-group">
                <label class="form-checl-lable">Albierto</label>
                <input
                  type="checkbox"
                  class="form-check-input ml-4"
                  v-model="miercoles"
                />
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>

            <div class="col-md-6">
              <label class="form-checl-lable"><strong>Jueves</strong></label>
              <div class="form-group">
                <label class="form-checl-lable">Albierto</label>
                <input
                  type="checkbox"
                  class="form-check-input ml-4"
                  v-model="jueves"
                />
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>

            <div class="col-md-6 pl-3">
              <label class="form-checl-lable"><strong>Viernes</strong></label>
              <div class="form-group">
                <label class="form-checl-lable">Albierto</label>
                <input
                  type="checkbox"
                  class="form-check-input ml-4"
                  v-model="viernes"
                />
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>
            <div class="col-md-6">
              <label class="form-checl-lable"><strong>Sabado</strong></label>
              <div class="form-group">
                <label class="form-checl-lable">Albierto</label>
                <input
                  type="checkbox"
                  class="form-check-input ml-4"
                  v-model="sabado"
                />
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>

            <div class="col-md-6 pl-3">
              <label class="form-checl-lable"><strong>Domingo</strong></label>
              <div class="form-group">
                <label class="form-checl-lable">Albierto</label>
                <input
                  type="checkbox"
                  class="form-check-input ml-4"
                  v-model="domingo"
                />
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>

            <div class="col-md-12 pl-3">
              <div v-if="lunes">
                <label class="typo__label"><strong>Lunes</strong></label>
                <div class="form-group">
                  <label class="form-checl-lable">Cierras a medio dia</label>
                  <input
                    type="checkbox"
                    class="form-check-input ml-4"
                    v-model="lunes_medio"
                  />
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hAbre_el_lunes"
                  required
                  invalidFeedback="Coloca el Hora abre el Lunes"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora abre el Lunes</span
                  >
                </mdb-input>

                <div v-if="lunes_medio">
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hCierra_el_lunes_porlamanana"
                    required
                    invalidFeedback="Coloca el Hora cierra el Lunes por la manana"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora cierra el Lunes por la manana</span
                    >
                  </mdb-input>
                  <!-- <mdb-input
                            class="mb-3 mt-0"
                            v-model="hCierra_el_lunes_porlatarde"
                            required
                            invalidFeedback="Coloca el hora cierra el Lunes por la tarde" >
                            <span class="input-group-text md-addon" slot="prepend">A que hora cierra el Lunes por la tarde</span>
                          </mdb-input> -->

                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hAbre_el_lunes_porlatarde"
                    required
                    invalidFeedbacxk="Coloca el Hora abre el Lunes por la tarde"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora abre el Lunes por la tarde</span
                    >
                  </mdb-input>
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hCierra_el_lunes"
                  required
                  v-if="lunes"
                  invalidFeedback="Coloca el Hora cierra el Lunes"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora cierra el Lunes</span
                  >
                </mdb-input>
              </div>

              <div v-if="martes">
                <label class="typo__label"><strong>Martes</strong></label>
                <div class="form-group">
                  <label class="form-checl-lable">Cierras a medio dia</label>
                  <input
                    type="checkbox"
                    class="form-check-input ml-4"
                    v-model="martes_medio"
                  />
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hAbre_el_martes"
                  required
                  invalidFeedback="Coloca el Hora abre el Martes"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora abre el Martes</span
                  >
                </mdb-input>

                <div v-if="martes_medio">
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hCierra_el_martes_porlamanana"
                    required
                    invalidFeedback="Coloca el Hora cierra el Martes por la manana"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora cierra el Martes por la manana</span
                    >
                  </mdb-input>
                  <!-- <mdb-input
                            class="mb-3 mt-0"
                            v-model="hCierra_el_martes_porlatarde"
                            required
                            invalidFeedback="Coloca el hora cierra el Martes por la tarde" >
                            <span class="input-group-text md-addon" slot="prepend">A que hora cierra el Martes por la tarde</span>
                          </mdb-input> -->
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hAbre_el_martes_porlatarde"
                    required
                    invalidFeedback="Coloca el Hora abre el Martes por la tarde"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora abre el martes por la tarde</span
                    >
                  </mdb-input>
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hCierra_el_martes"
                  required
                  v-if="martes"
                  invalidFeedback="Coloca el Hora cierra el Martes"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora cierra el Martes</span
                  >
                </mdb-input>
              </div>

              <div v-if="miercoles">
                <label class="typo__label"><strong>Miercoles</strong></label>
                <div class="form-group">
                  <label class="form-checl-lable">Cierras a medio dia</label>
                  <input
                    type="checkbox"
                    class="form-check-input ml-4"
                    v-model="miercoles_medio"
                  />
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hAbre_el_miercoles"
                  required
                  invalidFeedback="Coloca el Hora abre el Miercoles"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora abre el Miercoles</span
                  >
                </mdb-input>

                <div v-if="miercoles_medio">
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hCierra_el_miercoles_porlamanana"
                    required
                    invalidFeedback="Coloca el Hora cierra el Miercoles por la manana"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora cierra el Miercoles por la manana</span
                    >
                  </mdb-input>
                  <!-- <mdb-input
                            class="mb-3 mt-0"
                            v-model="hCierra_el_miercoles_porlatarde"
                            required
                            invalidFeedback="Coloca el hora cierra el Miercoles por la tarde" >
                            <span class="input-group-text md-addon" slot="prepend">A que hora cierra el Miercoles por la tarde</span>
                          </mdb-input> -->
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hAbre_el_miercoles_porlatarde"
                    required
                    invalidFeedback="Coloca el Hora abre el Miercoles por la tarde"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora abre el Miercoles por la tarde</span
                    >
                  </mdb-input>
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hCierra_el_miercoles"
                  required
                  v-if="miercoles"
                  invalidFeedback="Coloca el Hora cierra el miercoles"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora cierra el Miercoles</span
                  >
                </mdb-input>
              </div>
              <div v-if="jueves">
                <label class="typo__label"><strong>Jueves</strong></label>
                <div class="form-group">
                  <label class="form-checl-lable">Cierras a medio dia</label>
                  <input
                    type="checkbox"
                    class="form-check-input ml-4"
                    v-model="jueves_medio"
                  />
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hAbre_el_jueves"
                  required
                  invalidFeedback="Coloca el Hora abre el Jueves"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora abre el Jueves</span
                  >
                </mdb-input>

                <div v-if="jueves_medio">
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hCierra_el_jueves_porlamanana"
                    required
                    invalidFeedback="Coloca el Hora cierra el Jueves por la manana"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora cierra el Jueves por la manana</span
                    >
                  </mdb-input>
                  <!-- <mdb-input
                            class="mb-3 mt-0"
                            v-model="hCierra_el_jueves_porlatarde"
                            required
                            invalidFeedback="Coloca el hora cierra el Jueves por la tarde" >
                            <span class="input-group-text md-addon" slot="prepend">A que hora cierra el Jueves por la tarde</span>
                          </mdb-input> -->
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hAbre_el_jueves_porlatarde"
                    required
                    invalidFeedback="Coloca el Hora abre el Jueves por la tarde"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora abre el Jueves por la tarde</span
                    >
                  </mdb-input>
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hCierra_el_jueves"
                  required
                  v-if="jueves"
                  invalidFeedback="Coloca el Hora cierra el Jueves"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora cierra el jueves</span
                  >
                </mdb-input>
              </div>

              <div v-if="viernes">
                <label class="typo__label"><strong>Viernes</strong></label>
                <div class="form-group">
                  <label class="form-checl-lable">Cierras a medio dia</label>
                  <input
                    type="checkbox"
                    class="form-check-input ml-4"
                    v-model="viernes_medio"
                  />
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hAbre_el_viernes"
                  required
                  invalidFeedback="Coloca el Hora abre el Viernes"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora abre el Viernes</span
                  >
                </mdb-input>

                <div v-if="viernes_medio">
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hCierra_el_viernes_porlamanana"
                    required
                    invalidFeedback="Coloca el Hora cierra el Viernes por la manana"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora cierra el Viernes por la manana</span
                    >
                  </mdb-input>
                  <!-- <mdb-input
                            class="mb-3 mt-0"
                            v-model="hCierra_el_viernes_porlatarde"
                            required
                            invalidFeedback="Coloca el hora cierra el Viernes por la tarde" >
                            <span class="input-group-text md-addon" slot="prepend">A que hora cierra el Viernes por la tarde</span>
                          </mdb-input> -->
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hAbre_el_viernes_porlatarde"
                    required
                    invalidFeedback="Coloca el Hora abre el Viernes por la tarde"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora abre el Viernes por la tarde</span
                    >
                  </mdb-input>
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hCierra_el_viernes"
                  required
                  v-if="viernes"
                  invalidFeedback="Coloca el Hora cierra el Viernes"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora cierra el Viernes</span
                  >
                </mdb-input>
              </div>

              <div v-if="sabado">
                <label class="typo__label"><strong>Sabado</strong></label>
                <div class="form-group">
                  <label class="form-checl-lable">Cierras a medio dia</label>
                  <input
                    type="checkbox"
                    class="form-check-input ml-4"
                    v-model="sabado_medio"
                  />
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hAbre_el_sabado"
                  required
                  invalidFeedback="Coloca el Hora abre el Sabado"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora abre el Sunes</span
                  >
                </mdb-input>

                <div v-if="sabado_medio">
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hCierra_el_sabado_porlamanana"
                    required
                    invalidFeedback="Coloca el Hora cierra el Sabado por la manana"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora cierra el Sabado por la manana</span
                    >
                  </mdb-input>
                  <!-- <mdb-input
                            class="mb-3 mt-0"
                            v-model="hCierra_el_sabado_porlatarde"
                            required
                            invalidFeedback="Coloca el hora cierra el Sabado por la tarde" >
                            <span class="input-group-text md-addon" slot="prepend">A que hora cierra el Sabado por la tarde</span>
                          </mdb-input> -->
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hAbre_el_sabado_porlatarde"
                    required
                    invalidFeedback="Coloca el Hora abre el Sabado por la tarde"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora abre el Sabado por la tarde</span
                    >
                  </mdb-input>
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hCierra_el_sabado"
                  required
                  v-if="sabado"
                  invalidFeedback="Coloca el Hora cierra el Sabado"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora cierra el Sabado</span
                  >
                </mdb-input>
              </div>

              <div v-if="domingo">
                <label class="typo__label"><strong>Domingo</strong></label>
                <div class="form-group">
                  <label class="form-checl-lable">Cierras a medio dia</label>
                  <input
                    type="checkbox"
                    class="form-check-input ml-4"
                    v-model="domingo_medio"
                  />
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hAbre_el_domingo"
                  required
                  invalidFeedback="Coloca el Hora abre el Lunes"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora abre el Domingo</span
                  >
                </mdb-input>

                <div v-if="domingo_medio">
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hCierra_el_domingo_porlamanana"
                    required
                    invalidFeedback="Coloca el Hora cierra el Domingo por la manana"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora cierra el Domingo por la manana</span
                    >
                  </mdb-input>
                  <!-- <mdb-input
                            class="mb-3 mt-0"
                            v-model="hCierra_el_domingo_porlatarde"
                            required
                            invalidFeedback="Coloca el hora cierra el Lunes por la tarde" >
                            <span class="input-group-text md-addon" slot="prepend">A que hora cierra el Domingo por la tarde</span>
                          </mdb-input> -->
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="hAbre_el_domingo_porlatarde"
                    required
                    invalidFeedback="Coloca el Hora abre el Domingo por la tarde"
                  >
                    <span class="input-group-text md-addon" slot="prepend"
                      >A que hora abre el Domingo por la tarde</span
                    >
                  </mdb-input>
                </div>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="hCierra_el_domingo"
                  required
                  v-if="domingo"
                  invalidFeedback="Coloca el Hora cierra el Lunes"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >A que hora cierra el Domingo</span
                  >
                </mdb-input>
              </div>
            </div>
          </div>
          <div center slot="footer">
            <mdb-btn color="secondary" @click.native="modalHorario = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="updateLocationSchedule"
              :disabled="isLoadingHorario"
            >
              <span v-if="!isLoadingHorario">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingHorario"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalAnadirservicio"
          class="text-center"
          style="max-height: 90vh"
          @close="modalAnadirservicio = false"
          :close="true"
        >
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>
          <div class="row text-left">
            <!-- <div class="col-md-12 pt-3">
                 <label class="typo__label  font-weight-bold">Google Services</label>
                    <multiselect
                    v-model="selected_loc_categories"
                    placeholder="Seleccione un Category"
                    label="category_id"
                    track-by="id"
                    :options="location_categories"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :multiple="false"
                    :taggable="false"
                    @input="getpossibleCategories()"
                    ></multiselect>
              </div> -->
            <!-- <div class="col-md-12 ">
                 <label class="typo__label  font-weight-bold">Possible categories</label>
                    <multiselect
                    v-model="selected_possible_categories"
                    placeholder="Seleccione un Category"
                    label="display_name"
                    track-by="id"
                    :options="possible_categories"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :multiple="false"
                    :taggable="false"
                    @input="getpossibleServices()"
                    ></multiselect>
              </div> -->
            <div class="col-md-12 pt-3" v-if="possible_services.length > 0">
              <label class="typo__label font-weight-bold"
                >Google Services</label
              >
              <multiselect
                v-model="selected_google_services_ids"
                placeholder="Seleccione un Category"
                label="name"
                track-by="id"
                :options="possible_services"
                :close-on-select="true"
                :clear-on-select="false"
                :multiple="false"
                :taggable="false"
              ></multiselect>
            </div>
            <div class="col-md-12 pt-3" v-if="showtipodeservecio">
              <!-- <label class="typo__label">Nombre</label> -->
              <mdb-input
                class="mb-3 mt-0"
                v-model="tipo_de_servicio"
                required
                invalidFeedback="Coloca el Nombre"
              >
                <span class="input-group-text md-addon" slot="prepend"
                  >Tipo de Servicio</span
                >
              </mdb-input>
            </div>
            <div class="col-md-6 ml-4">
              <!-- <input type="checkbox" 
                  :value="cerrado"
                  > -->

              <div class="form-group mt-2">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="tine_precio"
                />
                <label class="form-checl-lable">Tiene precio</label>
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>
            <div v-if="tine_precio">
              <div class="col-md-12">
                <!-- <label class="typo__label">Nombre</label> -->
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="moneda"
                  required
                  invalidFeedback="Coloca el Moneda"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >Moneda</span
                  >
                </mdb-input>
              </div>
              <div class="col-md-12">
                <!-- <label class="typo__label">Nombre</label> -->
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="precio"
                  required
                  invalidFeedback="Coloca el Precio"
                >
                  <span class="input-group-text md-addon" slot="prepend"
                    >Precio</span
                  >
                </mdb-input>
              </div>
            </div>
          </div>

          <div center slot="footer">
            <mdb-btn
              color="secondary"
              @click.native="modalAnadirservicio = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="setLocationService"
              :disabled="isLoadingAnadirservicio"
            >
              <span v-if="!isLoadingAnadirservicio">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingAnadirservicio"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>
      <CContainer>
        <CModal color="primary"
          :show.sync="modalAnadirPost"
          class="text-center"
          style="max-height: 90vh"
          @close="modalAnadirPost = false"
          :close="true">
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>
          <div>
            <label for="idioma">Lenguage Code</label>
            <multiselect id="idioma"
              placeholder="Seleccione un Idioma"
              aria-label="Default select example"
              track-by="id"
              :close-on-select="true"
              :clear-on-select="false"
              :multiple="false"
              :taggable="false"
              label = "label"
              :allow-empty="required"
              :options="[
              ' ',
              { label: 'Español', value: 'español',id:1 },
              { label: 'Ingles', value: 'ingles',id:2 },
              ]" v-model="lCode">
            </multiselect>
          </div>
          <div>
            <label for="topic">Topic type</label>
            <multiselect id="topic"
              label = "label"
              placeholder="Seleccione un Topic"
              aria-label="Default select example"
              track-by="id"
              :close-on-select="true"
              :clear-on-select="false"
              :multiple="false"
              :taggable="false"
              :allow-empty="required"
              :options="[
              ' ',
              { label: 'Post contains basic information, like summary and images', value: 'STANDARD',id:2 },
              { label: 'Post contains basic information and events', value: 'EVENT',id:3 },
              { label: 'Post contains basic information, an event and offer related content (e.g. coupon code)', value: 'OFFER', id:4 },
              { label: 'High-priority, and timely announcements related to an ongoing event.These types of posts are not always available for authoring', value: 'ALERT',id:5 },
              ]" v-model="tType">
            </multiselect>
          </div>
          <div v-if="tType.id == 5">
            <label for="alert">Alert type</label>
            <CInput id="alert" type="text"></CInput>
          </div>
          <div>
            <label for="texto">Texto</label>
            <CTextarea placeholder="escribe tu post" rows="3" id="texto" v-model="tPost"></CTextarea>
          </div>
          
          <div v-if="tType.id != 4">
            <label for="action">Call to action type</label>
            <multiselect id="action"
              label = "label"
              aria-label="Default select example"
              placeholder = "Seleccione una accion"
              track-by="id"
              :close-on-select="true"
              :clear-on-select="false"
              :multiple="false"
              :taggable="false"
              :allow-empty="required"
              :options="[
              ' ',
              { label: 'This post wants a user to book an appointmen/table/etc.', value: 'BOOK',id:3 },
              { label: 'This post wants a user to order something', value: 'ORDER',id:4 },
              { label: 'This post wants a user to browse a product catalog.', value: 'SHOP',id:5 },
              { label: 'This post wants a user to learn more (at their website)', value: 'LEARN_MORE',id:6 },
              { label: 'This post wants a user to register/sign up/join something.', value: 'SIGN_UP',id:7 },
              { label: 'This post wants a user to call the business', value: 'CALL',id:8 },
              ]" v-model="cActiontype">
            </multiselect>
          </div>
          <div class="row text-left" v-if="tType.id == 3 || tType.id == 4">
            <div class="col-md-6">
              <div class="form-group">
                <label><strong>Dia de Apertura</strong></label>
                <datetime
                  type="date"
                  input-id="fecha-input"
                  format="yyyy-MM-dd"
                  v-model="start_date"
                ></datetime>
                
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label><strong>Dia de Cierre</strong></label>
                <datetime
                  type="date"
                  input-id="fechafin-input"
                  format="yyyy-MM-dd"
                  v-model="end_date"
                ></datetime>
              </div>
            </div>
            <div class="col-md-6 ml-4">
              <!-- <input type="checkbox" 
                  :value="cerrado"
                  > -->

              <div class="form-group">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="cerrado"
                />
                <label class="form-checl-lable"><strong>Horario del evento</strong></label>
              </div>
              <!-- @change="select_row($event, data.item)" @update="checkboxUpdatebutton(button.button_outline)" -->
            </div>
            <div v-if="cerrado">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="typo__label"
                    ><strong>Hora de Apertura : &nbsp;&nbsp; </strong></label
                  >
                  <!-- <mdb-input
                      class="mb-3 mt-0"
                      v-model="hApertura"
                      required
                      invalidFeedback="Coloca el Nombre"
                    > -->
                  <vue-timepicker
                    v-model="hApertura"
                    format="HH:mm"
                  ></vue-timepicker>
                </div>
                <!-- <span class="input-group-text md-addon" slot="prepend">Hora de Apertura</span> -->
                <!-- </mdb-input> -->
              </div>
              <div class="col-md-12">
                <!-- <label class="typo__label">Nombre</label> -->
                <!-- <mdb-input
                  class="mb-3 mt-0"
                  v-model="hClausura"
                  required
                  invalidFeedback="Coloca el Nombre"
                > -->
                <div class="form-group">
                  <label class="typo__label"
                    ><strong>Hora de Clausura : &nbsp;&nbsp; </strong>
                  </label>
                  <vue-timepicker
                    v-model="hClausura"
                    format="HH:mm"
                  ></vue-timepicker>
                </div>
                <!-- <span class="input-group-text md-addon" slot="prepend">Hora de Clausura</span> -->
                <!-- </mdb-input> -->
              </div>
              <label for="evenT">Even tittle</label><CInput id="evenT" v-model="enventT"></CInput>
            </div>
            <div v-if="tType.id == 4">
              <label for="coupon">Coupon code</label><CInput id="coupon" v-model="coupon"></CInput>
              <label for="redeem">Redeem online URL</label><CInput id="redeem" v-model="redeem"></CInput>
              <label for="terms">Terms conditions</label><CInput id="terms" v-model="terms"></CInput>
            </div>
          </div>
          <div v-if="cActiontype.id ==2 || cActiontype.id ==3 ||cActiontype.id ==4 ||cActiontype.id ==5 || cActiontype.id ==6 || cActiontype.id ==7">
            <label for="actionurl">Call to action url</label>
            <CInput id="actionurl" v-model="cActionurl"></CInput>
          </div>
          <div v-if="tType.id != 5">
            <label for="media">Medias</label>
            <multiselect id="media"
              label = "name"
              aria-label="Default select example"
              :options=medias v-model="mediaSelected">
            </multiselect>
          </div>
          <div center slot="footer">
            <mdb-btn
              color="secondary"
              @click.native="modalAnadirPost = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="getPost"
            >
              <span>Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingAnadirservicio"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>
      <CContainer>
        <CModal color="primary"
          :show.sync="modalAnadirImagen"
          class="text-center"
          style="max-height: 90vh"
          @close="modalAnadirImagen = false"
          :close="true">
          <div slot="header">
            <p class="heading">
              <strong>{{ modalName }}</strong>
            </p>
          </div>
          <div class="col-md-12 pt-3">
            <label for="file">Binary</label>
            <mdbInput type="file" v-model="file" id="file"></mdbInput>
          </div>
          <div>
            <label for="filename">Filename</label>
            <CInput type="text" id="filename" v-model="file" value="file"></CInput>
          </div>
          <div>
            <label for="imgvd">Imagen/Video</label>
            <multiselect id="imgvd" v-model="mediaitem"
              aria-label="Default select example"
              label = "label"
              :options="[
              ' ',
              { label: 'Media item is a photo. In this version, only photos are supported', value: 'PHOTO' },
              { label: 'Media item is a video', value: 'VIDEO' },
              ]">
            </multiselect>
          </div>
          <div>
            <label for="categoria">Categoria</label>
            <multiselect id="Categoria" v-model="mediacategory"
              aria-label="Default select example"
              label = "label"
              :options="[
              ' ',
              { label: 'Unespecified category', value: 'CATEGORY_UNSPECIFIED' },
              { label: 'Cover photo. A location has only one cover photo', value: 'COVER' },
              { label: 'Profile photo. A location has only one profile photo', value: 'PROFILE' },
              { label: 'Logo photo', value: 'LOGO' },
              { label: 'Exterior media', value: 'EXTERIOR' },
              { label: 'Interior media', value: 'INTERIOR' },
              { label: 'Product media', value: 'PRODUCT' },
              { label: 'At-work media', value: 'AT_WORK' },
              { label: 'Foot and drink media', value: 'FOOD_AND_DRINK' },
              { label: 'Menu media', value: 'MENU' },
              { label: 'Common area media', value: 'COMMON_AREA' },
              { label: 'Rooms media', value: 'ROOMS' },
              { label: 'Teams media', value: 'TEAMS' },
              { label: 'Additional, uncategorized media', value: 'ADDITIONAL' },
              ]">
            </multiselect>
          </div>
          <div center slot="footer">
            <mdb-btn
              color="secondary"
              @click.native="modalAnadirImagen = false"
              >Cerrar</mdb-btn
            >
            <mdb-btn
              type="submit"
              class="ml-3"
              color="primary"
              @click="getImages"
            >
              <span>Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingAnadirservicio"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CModal>
      </CContainer>
    </template>

    <template>
      <CContainer>
        <CModal
          title="FTP"
          color="danger"
          :show.sync="sendFtp"
          class="text-center"
          style="top: 40px"
          @close="confirmar = false"
        >
          <mdbModalHeader center :close="false">
            <p class="heading">Se ha publicado el Ftp con exito.</p>
          </mdbModalHeader>

          <mdbModalFooter center slot="footer">
            <CButton color="danger" @click="sendFtp = false">Ok</CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>
    </template>

    <div>
      <CCard>
        <CCardHeader>
          <slot name="header">
            <i class="fas fa-images mr-2"></i>
            {{ caption }}
            <!-- <div class="text-right" v-if="type_show === 'table'">
              <CButton @click="changeView('card')">
                Card View
                <i class="fas fa-images"></i>
              </CButton>
            </div>
            <div class="text-right" v-else>
              <CButton @click="changeView('table')">
                Table View
                <i class="fa fa-table"></i>
              </CButton>
            </div> -->
          </slot>
        </CCardHeader>
        <CCardBody>
          <modals-container v-model="items" />
          <div>
            <template>
              <CContainer>
                <CModal
                  title="FTP"
                  color="primary"
                  :show.sync="modal"
                  class="text-center"
                  style="top: 40px"
                  @close="confirmar = false"
                  size="xl"
                >
                  <mdbModalHeader center :close="false" slot="header">
                    <p class="heading">{{ modalName }}</p>
                  </mdbModalHeader>

                  <mdbModalBody class="modal-body">
                    <Modal-create-quiz
                      :onClick="closeModalCreate"
                      v-if="modalName == 'Crear'"
                    ></Modal-create-quiz>
                    <Modal-edit-quiz
                      :onClick="closeModalCreate"
                      :webSite="quizSelected"
                      v-if="modalName == 'Editar'"
                    ></Modal-edit-quiz>
                  </mdbModalBody>

                  <!--  <modal-create-quiz :onClick="closeModalCreate" v-if="modalName=='Crear'"></modal-create-quiz>
                    <modal-edit-quiz
                      :onClick="closeModalCreate"
                      :webSite="quizSelected"
                      v-if="modalName=='Editar'"
                    ></modal-edit-quiz>
                  -->
                  <mdbModalFooter center slot="footer">
                    <CButton color="danger" @click="modal = false"
                      >Cancelar</CButton
                    >
                  </mdbModalFooter>
                </CModal>
              </CContainer>
            </template>
          </div>

          <div v-if="type_show === 'table'">
            <CRow class="pt-2 pb-3">
              <CCol sm="4">
                <!-- <CSelect :options="searchDropdownPartner_id" /> -->
                <label class="typo__label font-weight-bold"> Partner</label>
                <multiselect
                  v-model="selectedPartnerId"
                  placeholder="Seleccione un Partner"
                  label="value"
                  track-by="id"
                  :options="partners"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :multiple="false"
                  :taggable="false"
                ></multiselect>
                <!-- @input="onChangePartnerId()" -->

                <!-- <select
                      style="height:40px; width:300px; marginLeft:-20"
                      v-model="selectedPartnerId"
                      v-on:change="onChangePartnerId(selectedPartnerId)"
                    >
                      <option
                        v-for="(option,key) in partnerFilter"
                        :key="key"
                        v-bind:value="option.id"
                      >{{ option }}</option>
                    </select>-->
              </CCol>
              <CCol sm="4">
                <!-- <CSelect :options="searchDropdownName" /> -->
                <label class="typo__label font-weight-bold">City</label>
                <multiselect
                  v-model="selectedName"
                  placeholder="Seleccione un City"
                  label="name"
                  track-by="id"
                  :options="cities"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :multiple="false"
                  :taggable="true"
                  @input="onChangeName()"
                ></multiselect>
                <!--  <label class="typo__label  font-weight-bold"> City</label>
                    <treeselect
                    v-if="!isLoading"
                    v-model="locationSelected"
                    :multiple="true"
                    :options="locations1[0]"
                    @input="getfilterlocationName()"
                  />  -->

                <!-- <select
                      style="height:40px; width:300px"
                      v-model="selectedName"
                      v-on:change="onChangeName(selectedName)"
                    >
                      <option
                        v-for="(option,key) in searchDropdownName"
                        :key="key"
                        v-bind:value="option"
                      >{{ option}}</option>
                    </select>-->
              </CCol>
            </CRow>
            <CRow class="p-2 pl-4">
              <div v-if="row_data.length > 0">
                <span class="md-3">
                  <CButton
                    class="addonButton"
                    color="primary"
                    @click="openModalNombre('Nombre')"
                    >Nombre</CButton
                  >
                </span>
                <span class="p-2">
                  <CButton
                    color="primary addonButton"
                    @click="openModalDirection('Dirección')"
                    >Dirección</CButton
                  >
                </span>

                <span class="p-2">
                  <CButton
                    color="primary addonButton"
                    @click="openModalTelefono('Teléfonos')"
                    >Teléfonos</CButton
                  >
                </span>


                <span class="col-md-2 p-2">
                  <CButton
                    color="primary addonButton"
                    @click="openModalCategoriaprincipal('Categoría principal')"
                    >Añadir Categorías</CButton
                  >
                </span>
                <!-- <span class="p-2">
                <CButton color="primary" @click="openModalCategoriasadicionales('Categorías adicionales')">Categorías adicionales</CButton>
              </span> -->

                <span class="p-2">
                  <CButton
                    color="primary addonButton"
                    @click="openModalHorario('Horario')"
                    >Horario</CButton
                  >
                </span>
                <span class="p-2">
                  <CButton
                    color="primary addonButton"
                    @click="openModalHorarioespecial('Horario especial')"
                    >Horario especial</CButton
                  >
                </span>
                <span class="p-2">
                  <CButton
                    color="primary addonButton"
                    @click="openModalDescripcion('Descripción')"
                    >Descripción</CButton
                  >
                </span>

                <span class="p-2">
                  <CButton
                    color="primary addonButton"
                    @click="openModalAnadiratributo('Añadir atributo')"
                    >Añadir atributo</CButton
                  >
                </span>

                <span class="p-2">
                  <CButton
                    color="primary addonButton"
                    @click="openModalAnadirservicio('Servicios')"
                    >Añadir servicio</CButton
                  >
                </span>

                <span class="p-2">
                  <CButton
                  color="primary addonButton"
                  @click="openModalAnadirPost('Post')">
                  Añadir post
                  </CButton>
                </span>

                <span class="p-2">
                  <CButton
                  color="primary addonButton"
                  @click="openModalAnadirImagen('Imagen')">
                  Añadir imagen
                  </CButton>
                </span>
              </div>
            </CRow>
            <CDataTable
              responsive
              hover
              striped
              bordered
              small
              fixed
              :items="itemQuiz"
              :fields="fields"
              :dark="dark"
              :items-per-page="10"
              column-filter
              sorter
              pagination
            >
              <template slot="domain_id" slot-scope="data">
                <CCol>{{ data.item.domain_id.name }}</CCol>
              </template>
              <template slot="select" slot-scope="data">
                <CCol class="p-2 text-center">
                  <input
                    type="checkbox"
                    :checked="data.item.isChecked"
                    :value="data.item.id"
                    model="data.item.isChecked"
                    @change="select_row($event, data.item.id)"
                  />
                </CCol>
              </template>

              <template slot="info" slot-scope="data">
                <CCol class="text-center">
                  <!-- <CNav> -->
                  <CBadge
                    color="primary"
                    class="text-white p-2 mt-2 text-center"
                  >
                    <!-- <router-link :to="'/location/' + data.item.id">
                        <strong class="text-white">Info</strong>
                      </router-link> -->
                    <router-link
                      class="toggler-text"
                      :to="{
                        path: '/location/' + data.item.id,
                        query: { partner: selectedPartnerId.id },
                      }"
                      ><strong class="text-white">Info</strong></router-link
                    >
                  </CBadge>
                  <!-- <CDropdown placement="bottom-end" toggler-text="Acciones"> -->
                  <!-- <CDropdownItem>
                        <router-link
                          class="toggler-text"
                          :to="{ name: 'EditQuiz', params: { webSite: item }}"
                        >Nombre</router-link>
                      </CDropdownItem>
                      <CDropdownItem @click="selectQuizDelete(data.item)">Dirección</CDropdownItem>
                      <CDropdownItem @click="redirectToCreatePage(item.id)">Duplicar</CDropdownItem>
                      <CDropdownDivider />
                      <CDropdownItem @click="publicarFtp(data.item.id)">Publicar en FTP</CDropdownItem>
                      <CDropdownItem @click="quizPreview(data.item.id)">Quiz preview</CDropdownItem>
                      <CDropdownItem @click="redirectToanswerTab(item.id)">ver stats</CDropdownItem> -->
                  <!-- <CDropdownItem >Nombre</CDropdownItem>
                      <CDropdownItem >Dirección</CDropdownItem>
                      <CDropdownItem >Teléfono</CDropdownItem>
                      <CDropdownItem >Teléfono adicional</CDropdownItem>
                      <CDropdownItem >Categoría principal</CDropdownItem>
                      <CDropdownItem >Categorías adicionales</CDropdownItem>
                      <CDropdownItem >Horario</CDropdownItem>
                      <CDropdownItem >Horario especial</CDropdownItem>
                      <CDropdownItem >Descripción</CDropdownItem>
                      <CDropdownItem >Añadir atributo</CDropdownItem>
                      <CDropdownItem >Añadir servicio</CDropdownItem>
                      
                    </CDropdown> -->
                  <!-- </CNav> -->
                </CCol>
              </template>
            </CDataTable>
          </div>

          <div v-else>
            <CCard class="p-3">
              <CCardHeader>
                <CCardTitle>
                  <i class="cil-library mr-3"></i>Surveys
                </CCardTitle>
                <CRow class="pt-2">
                  <CCol class="p-0">
                    <!-- <CSelect :options="searchDropdownPartner_id" /> -->
                    <multiselect
                      v-model="selectedPartnerId"
                      placeholder="Seleccione un Partner"
                      label="value"
                      track-by="id"
                      :options="partners"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :multiple="false"
                      :taggable="false"
                    ></multiselect>
                  </CCol>
                  <CCol sm="4">
                    <multiselect
                      v-model="selectedName"
                      placeholder="Seleccione un Survey"
                      label="name"
                      track-by="id"
                      :options="surveys_temp"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :multiple="false"
                      :taggable="true"
                      @input="onChangeName()"
                    ></multiselect>
                  </CCol>
                  <CCol sm="4">
                    <!-- <CSelect :options="searchDropdownDate" /> -->
                    <CBadge color="light" class="float-right p-1">
                      <CDropdown color=" p-0" placement="bottom-end">
                        <template #toggler-content>
                          <i
                            class="fa fa-sort-amount-asc"
                            aria-hidden="true"
                          ></i>
                          <!-- <CIcon name="cil-settings" /> -->
                        </template>
                        <CDropdownItem
                          @click.native="getSortedquiz('createDateAsc')"
                        >
                          createDate
                          <i
                            class="fa fa-sort-amount-asc ml-2"
                            aria-hidden="true"
                          ></i>
                        </CDropdownItem>
                        <CDropdownItem
                          @click.native="getSortedquiz('createDateDesc')"
                        >
                          createDate
                          <i
                            class="fa fa-sort-amount-desc ml-2"
                            aria-hidden="true"
                          ></i>
                        </CDropdownItem>
                        <CDropdownItem
                          @click.native="getSortedquiz('stat_idAsc')"
                          >No of stat_ids
                          <i
                            class="fa fa-sort-alpha-asc ml-2"
                            aria-hidden="true"
                          ></i
                        ></CDropdownItem>
                        <CDropdownItem
                          @click.native="getSortedquiz('stat_idDesc')"
                          >No of stat_ids
                          <i
                            class="fa fa-sort-alpha-desc ml-2"
                            aria-hidden="true"
                          ></i
                        ></CDropdownItem>
                      </CDropdown>
                    </CBadge>
                  </CCol>
                </CRow>
              </CCardHeader>

              <div v-if="isLoading_quiz">
                <semipolar-spinner
                  :animation-duration="2000"
                  :size="80"
                  color="blue"
                ></semipolar-spinner>
              </div>
              <div v-else>
                <CRow class="mt-3">
                  <div
                    class="col-md-3"
                    v-for="item in pageOfItems"
                    :key="item.id"
                  >
                    <CCard class="shadow mb-5 bg-white rounded">
                      <!-- <img src="../../../public/img/Apache_logo.png" alt="..."  class="card-img" /> -->

                      <CCardBody class="box p-0" backgroupcolor="light">
                        <!-- :style="{
                      backgroundImage: `url(${getimage(item.title_img[0])})`
                      
                   }" -->
                        <CImg :src="getimage(item.title_img[0])" class="p-0" />

                        <!-- backgroundImage: `url(${item.title_img.image_url -->
                      </CCardBody>
                      <span class="text-center p-3"
                        ><strong>{{ item.display_name }}</strong></span
                      >
                      <!-- </div>
                    >{{item.name}}</CCardBody>-->
                      <CCardFooter align="right">
                        <CRow>
                          <!-- <CCardBody color="light" align="center" class="">Respuestes</CCardBody> -->

                          <CCardText
                            class="shadow-none p-2 bg-light rounded ml-4"
                            >{{ getcomments(item.id) }} respuestas</CCardText
                          >
                          <!-- <CIcon name="cil-options" /> -->
                          <CDropdown toggler-text class="ml-3">
                            <CDropdownItem @click="quizPreview(item.id)"
                              >preview</CDropdownItem
                            >
                            <!-- <CDropdownItem @click="selectQuizEdit(item,pageOfItems)">Editar</CDropdownItem> -->
                            <!-- <CDropdownItem @click="redirectToEditPage(item)">Editar</CDropdownItem> -->
                            <CDropdownItem>
                              <router-link
                                class="toggler-text"
                                :to="{
                                  name: 'EditQuiz',
                                  params: { webSite: item },
                                }"
                                >Editar</router-link
                              >
                            </CDropdownItem>
                            <!-- <CDropdownItem @click="redirectToCreatePage(item.id)">Duplicar</CDropdownItem> -->
                            <CDropdownItem>
                              <router-link
                                class="toggler-text"
                                :to="{
                                  name: 'DuplicateQuiz',
                                  params: { webSite: item },
                                }"
                                >Duplicar</router-link
                              >
                            </CDropdownItem>
                            <CDropdownDivider />
                            <CDropdownItem @click="publicarFtp(item.id)"
                              >Publicar en FTP</CDropdownItem
                            >
                            <CDropdownItem @click="selectQuizDelete(item)"
                              >Eliminar</CDropdownItem
                            >
                            <CDropdownItem @click="redirectToanswerTab(item.id)"
                              >ver stats</CDropdownItem
                            >
                          </CDropdown>
                        </CRow>
                      </CCardFooter>
                    </CCard>
                  </div>
                </CRow>
              </div>
              <div class="card-footer pb-0 pt-3">
                <jw-pagination
                  :items="itemQuiz"
                  @changePage="onChangePageitem"
                  :labels="customLabels"
                  :pageSize="12"
                ></jw-pagination>
              </div>
            </CCard>
          </div>
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { shuffleArray } from "@/shared/utils";
import store from "../../store";
import Multiselect from "vue-multiselect";
import { SemipolarSpinner } from "epic-spinners";
import ModalCreateQuiz from "../notifications/ModalCreateQuiz";
import ModalEditQuiz from "../notifications/ModalEditQuiz";
import EditQuiz from "./EditQuiz";
import Constant from "../../config/const";
import backgroundUrl from "../../../public/img/Apache_logo.png";

import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Datetime } from "vue-datetime";
import moment from "moment";
// import ToggleButton from 'vue-js-toggle-button';

import VueTimepicker from "vue2-timepicker";

// CSS
import "vue2-timepicker/dist/VueTimepicker.css";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbTimePicker2,
  mdbCol,
} from "mdbvue";

// import { mdbTimePicker2, mdbContainer, mdbRow, mdbCol } from "mdbvue";

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};

export default {
  name: "table-partners",
  inheritAttrs: false,
  components: {
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    Multiselect,
    ModalCreateQuiz,
    ModalEditQuiz,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle,
    Treeselect,
    datetime: Datetime,
    mdbTimePicker2,
    VueTimepicker,

    // ToggleButton
  },
  props: {
    caption: {
      type: String,
      default: "Table",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: [Array, Function],
      default: () => [],
    },
    // fields: {
    //   type: [Array, Object],
    //   default: () => [],
    // },
    perPage: {
      type: Number,
      default: 5,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      fields: [
        { key: "select", label: "Select", sortable: false },
        { key: "locationName", label: "Nombre", sortable: true },
        { key: "address", label: "Address", sortable: true },
        {
          key: "comunidad_autonoma",
          label: "comunidad_autonoma",
          sortable: true,
        },
        { key: "status", label: "status", sortable: true },
        { key: "primaryPhone", label: "primaryPhone" },
        { key: "info", label: "Info" },
        // { key: "acciones", label: "Acciones" },

        // { key: "stat_ids", label: "stat_ids" }
      ],
      itemQuiz: [],
      select_checkbox: [],
      itemQuizPartner: [],
      backgroundUrl,
      pageOfItems: [],
      customLabels,
      image: { url: "img/avatars/1.jpg" },
      type_show: "table",
      currentPage: 1,
      modalCreate: false,
      modal: false,
      isLoadingLine: false,
      isLoading: false,
      isLoading_quiz: false,
      modalName: "",
      confirmar: false,
      sendFtp: false,
      quizSelected: {},
      searchDropdownName: [],
      searchDropdownPartner_id: [],
      searchDropdownDate: [],
      temp_Quiz: [],
      selectedPartnerId: "",
      selectedName: "",
      partners: [],
      selectedSurveys: [],
      selectedDate: "",
      surveys: [],
      surveys_temp: [],
      locationSelected: [],
      locations: [],
      cities: [],
      locations1: [[]],
      city: [],
      city_temp: [],
      partner_ids: [],
      quiz_ids: [],
      partnerFilter: [],
      range: [],
      imagesByQuiz: [],
      comenzados: [],
      row_data: [],
      isSelected: [],
      modalInfo: false,
      modalNombre: false,
      modalDirection: false,

      modalTelefono: false,
      modalTelefonoadicional: false,
      modalCategoriaprincipal: false,
      modalCategoriasadicionales: false,
      modalHorario: false,
      modalHorarioespecial: false,
      modalDescripcion: false,
      modalAnadiratributo: false,
      modalAnadirservicio: false,
      modalAnadirPost: false,
      modalAnadirImagen: false,
      categoriaPrincipal:false,

      lCode: {},
      tType: {},
      tPost: "",
      cActiontype: {},
      cActionurl: "",
      medias: [],
      mediaSelected: [],

      eventT:"",
      coupon:"",
      redeem:"",
      terms:"",

      file: [],
      fileConverted: [],
      file64:"",
      filename:"",
      mediaitem:"",
      mediacategory:"",
      mediaId: "",
      mediaUrl: [],

      isLoadingnombre: false,
      isLoadingDirection: false,
      isLoadingTelefono: false,
      isLoadingTelefonoadicional: false,
      isLoadingCategoriaprincipal: false,
      isLoadingCategoriasadicionales: false,
      isLoadingHorario: false,
      isLoadingHorarioespecial: false,
      isLoadingDescripcion: false,
      isLoadingAnadiratributo: false,
      isLoadingAnadirservicio: false,
      isLoadinginfo: false,
      cerrado: false,
      lunes: false,
      martes: false,

      miercoles: false,
      jueves: false,
      viernes: false,
      sabado: false,
      domingo: false,
      tine_precio: false,

      lunes_medio: false,
      martes_medio: false,
      miercoles_medio: false,
      jueves_medio: false,
      viernes_medio: false,
      sabado_medio: false,
      domingo_medio: false,

      nombre: "",
      store_code: "",

      region: "",
      postal: "",
      area_admin: "",
      localidad: "",
      direction: "",

      telefono: "",

      telefono_add: "",

      gCategories: "",
      selected_categories: "",
      selected_loc_categories: "",
      location_categories: [],
      selected_possible_categories: {},
      possible_categories: [],
      possiblecat: [],
      possible_services: [],
      showtipodeservecio: false,
      loccategories: [],

      description: "",

      gAttribute: "",

      start_date: "",
      end_date: "",
      hApertura: moment().format("hh:mm"),
      hClausura: moment().format("hh:mm"),

      hCierra_el_lunes_porlamanana: "",
      hCierra_el_lunes_porlatarde: "",
      hAbre_el_lunes_porlatarde: "",

      hCierra_el_martes_porlamanana: "",
      hCierra_el_martes_porlatarde: "",
      hAbre_el_martes_porlatarde: "",

      hCierra_el_miercoles_porlamanana: "",
      hCierra_el_miercoles_porlatarde: "",
      hAbre_el_miercoles_porlatarde: "",

      hCierra_el_jueves_porlamanana: "",
      hCierra_el_jueves_porlatarde: "",
      hAbre_el_jueves_porlatarde: "",

      hCierra_el_viernes_porlamanana: "",
      hCierra_el_viernes_porlatarde: "",
      hAbre_el_viernes_porlatarde: "",

      hCierra_el_sabado_porlamanana: "",
      hCierra_el_sabado_porlatarde: "",
      hAbre_el_sabado_porlatarde: "",

      hCierra_el_domingo_porlamanana: "",
      hCierra_el_domingo_porlatarde: "",
      hAbre_el_domingo_porlatarde: "",

      hAbre_el_lunes: "",
      hCierra_el_lunes: "",

      hAbre_el_martes: "",
      hAbre_el_miercoles: "",
      hAbre_el_jueves: "",
      hAbre_el_viernes: "",
      hAbre_el_sabado: "",
      hAbre_el_domingo: "",

      hCierra_el_martes: "",
      hCierra_el_miercoles: "",
      hCierra_el_jueves: "",
      hCierra_el_viernes: "",
      hCierra_el_sabado: "",
      hCierra_el_domingo: "",

      gServices: "",
      tipo_de_servicio: "",
      moneda: "",
      precio: "",

      selected_google_services_ids: {},

      actualAttribute: [],
      actualAttributeSelected: {},
      possibleAttributeSelected: {},
      possibleAttribute: [],

      possibleAttributeValues: [],
      possibleAttributeValueSelected: [],
      google_attribute_bool: false,
      google_attribute_url: "",
      pickerValue: "",
    };
  },
  updated(){
    console.log("que me llega aqui",this.row_data)
  },
  computed: {
    items: function () {
      const items = this.locations;
      this.itemQuiz = this.locations;
      this.temp_Quiz = this.locations;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function () {
      return this.getRowCount();
    },
    captions: function () {
      return this.fields;
    },
  },
  async mounted() {
    var respuesta = await this.getPartners();
    await this.mediaGetter();
    // await this.getQuizes();
    await this.getcommenzadosCount();
    // await this.getlocationCategories();
    // await this.getActualLocationAttributes();
  },
  methods: {

    rowClicked(item, index, column, e) {
      if (!["INPUT", "LABEL"].includes(e.target.tagName)) {
        this.check(item);
      }
    },
    check(item) {
      console.log(item, item.id);
      const val = Boolean(this.usersData[item.id]._selected);
      this.$set(this.usersData[item.id], "_selected", !val);
    },

    select_row(e, item) {
      var local = [];
      var rowdatas = [];
      //console.log("selected checkbox", item);
      //console.log("getCheckboxData value==>", item, "check", e.target.checked);
      if (e.target.checked) {
        local.push({ isCheck: e.target.checked, row_data: item });
        console.log("que hay en local",local)
        // this.row_data=[];

        local.forEach((val) => {
          // this.isSelected = e.isCheck ? e.isCheck : false;
          local.push(item);

          this.row_data.push(item);
        });

        this.getActualLocationAttributes();
        this.getlocationCategories();
      } else {
        this.selectAll = false;
        //console.log("local item :::: ", item);
        local.pop(item);
        this.row_data.pop(item);
      }
      // this.rowdatas=local;
      //console.log("local =>>>>", this.row_data);
    },


    async getPost(){
      var locations = this.row_data;
      console.log("que es esto", this.row_data)
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.loadPost(loc);
        });
      }
    },
    async loadPost(e){
      var payload = {
      language : this.lCode.value,
      topic_type : this.tType.value,
      summary : this.tPost,
      call_to_action_type : this.cActiontype.value,
      call_to_action_url:this.cActionurl,
      media : this.mediaSelected.id,
      offer_coupon_code: this.coupon,
      offer_redeem_url : this.redeem,
      offer_terms_conditions:this.terms,
      event_start_date : this.start_date,
      event_end_date :this.end_date,
      event_time: this.cerrado,
      event_start_time:this.hApertura,
      event_end_time:this.hClausura,
      event_title: this.enventT,
      row_data: e,
      };
      if(this.lCode == ""){
        payload.language = false
      }
      if(this.tType == ""){
        payload.topic_type = false
      }
      if(this.tPost == ""){
        payload.summary = false
      }
      if(this.cActiontype == ""){
        payload.call_to_action_type = false
      }
      if(this.cActionurl == ""){
        payload.call_to_action_url = false
      }
      if(!this.mediaSelected.id){
        payload.media = false
      }
      if(this.coupon == ""){
        payload.offer_coupon_code = false
      }
      if(this.redeem == ""){
        payload.offer_redeem_url = false
      }
      if(this.terms == ""){
        payload.offer_terms_conditions = false
      }
      if(this.start_date == ""){
        payload.event_start_date = false
      }
      if(this.end_date == ""){
        payload.event_end_date = false
      }
      if(this.hApertura == ""){
        payload.event_start_time = false
      }
      if(this.hClausura == ""){
        payload.event_end_time = false
      }
      if(this.eventT == ""){
        payload.event_title = false
      }
      if(!this.cerrado){
        payload.event_end_time = false
        payload.event_start_time = false
      }


      if(this.lCode == "" || this.tType == "" || this.tPost == "" || this.cActiontype == ""){
        alert("Faltan campos, no puedes continuar")
      }else{
        await store.dispatch("uploadPost", payload).then(() => {
      });
      this.modalAnadirPost = false;
      return;
      }
      
    },
    async getImages(){
      var locations = this.row_data;
      console.log("que llega aqui",locations)
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.mediaPost(loc);
          setTimeout(() => {
            this.loadImages(loc);
          }, "500")
        });
      }
    },
    async loadImages(e){
      var payload = {
        media_url: this.mediaUrl[0].media_url,
        media_id: this.mediaId,
        media_format: this.mediaitem.value,
        media_category: this.mediacategory.value,
        row_data: e,
      };
      
      if(this.file == ""|| this.mediaitem == "" || this.mediacategory == ""){
        alert("Faltan campos por rellenar")
      } else{
        await store.dispatch("uploadImages", payload).then(() => {
        
      });
      this.modalAnadirImagen = false;
      return;
      }
    },

    async getUrl(){
      var url = []
      var payload = {
        media_id : this.mediaId
      }
      await store.dispatch("getMediaUrl", payload).then(() => {
        url = store.getters.getMediaUrl
        console.log("MEDIAURL", url)
        this.mediaUrl = url

      })
    },

    async mediaPost(e){
      var media = []
      const fileImage = document.getElementById("file").files[0];

      this.file64 = await this.getBase64(fileImage)
      this.fileConverted = this.file64.replace(/^data:image\/\w+;base64,/, "")
      this.filename = fileImage.name
      var payload = {
        media: this.fileConverted,
        media_filename: this.filename,
        location_id: e
      }
      await store.dispatch("postMedias", payload).then(() => {
        media = store.getters.postMedias
        this.mediaId = media
        console.log("MEDIAID",this.mediaId)
        this.getUrl()
        return;
      });

    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async mediaGetter() {
      var medias = [];
      if (medias.length == 0) {
        await store.dispatch("getMedias").then(()=> {
          medias = store.getters.getMedias;
          this.medias = medias;
          return
        })
      } else {
        this.medias = medias;
        return
      }

    },

    async getPartners() {
      var partners = [];
      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getaccount").then(() => {
          partners = store.getters.getaccount;
          this.partners = partners;
          this.partnersArray = partners;

          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;

        ////console.log("partners ::::::::: ",partners);
        return;
      }
      this.isLoading = false;
    },
    customLabel({ locationName, city, description }) {
      return `${locationName} – ${city} – ${description}`;
    },
    async getlocation() {
      this.locations = [];

      var gbalocation = []; //store.getters.getalllocationbyaccount;
      //console.log("item location1111 ::::::===>", gbalocation.length, this.isLoading );
      var options = [];
      //console.log("gbalocation 12", gbalocation.length);
      var partner_ids = this.partner_ids;
      //console.log(partner_ids, "::::::::; partner_ids");
      var payload = {
        partner_id: partner_ids,
      };
      store.dispatch("getalllocationbyaccount", payload).then(() => {
        gbalocation = store.getters.getalllocationbyaccount;
        // //console.log("gbalocation", gbalocation);
        // var gbalocation_sorted = _.sortBy(
        //   gbalocation,
        //   "location.partner_id.value"
        // );
        var locationsByPartner = [];

        var prev_key = "";
        var data = [];
        var data1 = [];
        //console.log("gbalocation :::: ", gbalocation);
        this.locations = gbalocation;
        this.locations.forEach((loc) => {
          //console.log("loc :::: ", loc);
          // this.isSelected=false;
          loc.isChecked = false;
        });

        gbalocation.map((location) => {
          //console.log("@@@@!!!! :::: ", location);
          if (partner_ids.includes(location.partner_id[0])) {
            locationsByPartner.push(location);
            var custom_label =
              location.locationName +
              " - " +
              location.city +
              " - " +
              location.description;

            var key = location.partner_id[1];
            if (prev_key !== key) {
              //console.log( "@@@@@@@@@@@@@@2 main ", prev_key, key, data, custom_label);
              if (
                data.some((loc) => location.label === location.partner_id[1])
              ) {
                //console.log("already_exists");
                var index1 = _.findIndex(data, {
                  label: location.partner_id[1],
                });
                data[index1].children.push({
                  id: location.id,
                  label: custom_label,
                  isNew: true,
                });
              } else {
                //console.log("doesnot exists");
                data.push({
                  id: location.partner_id[0],
                  label: location.partner_id[1],
                  children: [
                    {
                      id: location.id,
                      label: custom_label,
                      isNew: true,
                    },
                  ],
                });
              }
              //console.log("data ::: ", data);
              prev_key = key;
            } else {
              var index1 = _.findIndex(data, { label: location.partner_id[1] });
              //console.log( "!!!!!!!!!!1 ", prev_key, index1, key, data, data[index1]);

              data[index1].children.push({
                id: location.id, //+"_"+key,
                label: custom_label,
                isNew: true,
              });
              //console.log( data[index1].children, key, "data[index1].children", custom_label);
            }
          }
        });
        //console.log("data ::: ", data);
        options.push(data);
        //console.log( "locationsByPartner ::::: ", options, locationsByPartner.length);
        this.isLoading = false;

        // this.locations = _.sortBy(locationunique, "locationName");
        var city = [];
        this.locations.forEach((loc) => {
          if (loc.city !== false) city.push({ id: loc.city, name: loc.city });

          if (this.row_data.includes(loc.id)) loc.isChecked = true;
        });
        this.getuniqueCity(city);
        // this.cities = city;
        this.locations = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();
        // this.locationsArray = _.sortBy(result, "locationName");
        this.locationsArray = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();

        this.locations1 = options;

        // //console.log("item location@@@: :::::===>", this.locations.length);
      });
    },

    async getlocationbycity() {
      //console.log("this.row_data", this.row_data);
      // this.selectAll =false;

      // this.itemQuiz.forEach((loc)=>{
      //   //console.log("loc :::: ", loc);
      //   this.isSelected=false;
      //   loc.isChecked=false;

      // })

      // this.row_data=[];
      this.isSelected = [];
      // this.isChecked =false;

      //console.log("this.row_data", this.row_data);
      var gbalocation = []; //store.getters.getalllocationbyaccount;
      //console.log("item location1111 ::::::===>", gbalocation.length, this.isLoading);
      var options = [];
      //console.log("gbalocation 12", gbalocation.length);
      var partner_ids = this.partner_ids;
      //console.log(partner_ids, "::::::::; partner_ids");
      var city = [];
      if (this.selectedName !== null) {
        city.push(this.selectedName.id);
      }
      var payload = {
        partner_id: partner_ids,
        citys: city,
      };
      store.dispatch("getlocationbycity", payload).then(() => {
        gbalocation = store.getters.getlocationbycity;
        //console.log("gbalocation ::::111 ", gbalocation);
        this.locations = gbalocation;

        this.locations = _(gbalocation)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();
        this.locations.forEach((loc) => {
          if (this.row_data.includes(loc.id)) loc.isChecked = true;
        });
        this.isLoading = false;
      });
    },

    getuniqueCity(city) {
      const cityunique = [
        ...new Map(city.map((item) => [item["name"], item])).values(),
      ];
      this.cities = _.sortBy(cityunique, "name"); //formunique;
    },
    async getQuizes() {
      // var location_ids = this.locationSelected;
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      // surveys = this.selectedSurveys;
      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };

      //console.log("payload in view ::: ", payload);
      this.isLoading_quiz = true;
      var quiz_ids = [];
      var image_ids = [];

      await store.dispatch("getQuizes", payload).then(() => {
        var quizes_data = store.getters.getQuizes;
        //console.log("quizes_data::: ", quizes_data);
        var count = 0;
        quizes_data.forEach((data) => {
          quiz_ids.push(data.id);
          image_ids.push(data.title_img[0]);
        });
        //console.log("=============?", image_ids, quiz_ids);
        this.quiz_ids = quiz_ids;

        if (quizes_data.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          // this.getreview_CountMonth(avgstarratingpermonth_location);
          this.surveys = quizes_data;
          this.surveys_temp = quizes_data;
          //console.log("this.surveys ::: ", this.surveys, quizes_data.length);
          // this.items = quizes_data;
        } else {
          this.surveys = [];
          this.items = [];
          this.quiz_ids = [];
        }
        this.isLoading_quiz = false;
        return;
      });
      //console.log("Quiz_ids in get quiz ::: ", quiz_ids);
      await this.getImagebyQuiz(image_ids);
      await this.getcommenzadosCount();
    },

    async getQuizesbyQuizid() {
      // var location_ids = this.locationSelected;
      var partner_ids = [];
      var surveys = [];
      var create_date = [];

      partner_ids = this.partner_ids;
      surveys = this.selectedSurveys;
      var payload = {
        partner_ids: partner_ids,
        quiz_ids: surveys,
        create_date: create_date,
      };

      //console.log("payload in view ::: ", payload);
      var quiz_ids = [];
      var image_ids = [];
      await store.dispatch("getQuizes", payload).then(() => {
        var quizes_data = store.getters.getQuizes;
        //console.log("quizes_data::: ", quizes_data);
        var count = 0;
        quizes_data.forEach((data) => {
          quiz_ids.push(data.id);
          image_ids.push(data.title_img[0]);
        });
        //console.log("============>", quiz_ids, image_ids);
        this.quiz_ids = quiz_ids;

        if (quizes_data.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          // this.getreview_CountMonth(avgstarratingpermonth_location);
          this.surveys = quizes_data;
          // this.surveys_temp=quizes_data;
          //console.log("this.surveys ::: ", this.surveys, quizes_data.length);
          // this.items = quizes_data;
        } else {
          this.surveys = [];
          this.items = [];
        }
        return;
      });
      await this.getImagebyQuiz(image_ids);
      await this.getcommenzadosCount();
    },

    async getImagebyQuiz(quiz_ids) {
      // var quiz_id = this.$route.params.itemID;
      //console.log("quiz_ids", quiz_ids);
      var image_url = "";
      if (quiz_ids.length > 0) {
        await store.dispatch("getImagebyQuiz", quiz_ids).then(() => {
          var imagebyQuizData = store.getters.getImagebyQuiz;
          //console.log("imagebyQuizData::: ", imagebyQuizData);
          this.imagesByQuiz = imagebyQuizData;
          //console.log("this.imagesByQuiz :: ", this.imagesByQuiz);
          // if(imagebyQuizData.length>0){
          //   image_url = imagebyQuizData[0].image_url
          // }
        });
        // await this.getimage();
      }
      // return image_url;
    },
    getimage(quiz_id) {
      var image_url = "";
      if (this.imagesByQuiz.length > 0) {
        this.imagesByQuiz.forEach((data) => {
          //console.log( "quiz_id :::: ", quiz_id, this.imagesByQuiz, quiz_id, image_url);
          if (quiz_id === data.id) {
            image_url = data.image_url;
          }
        });

        return image_url;
      }
    },
    getcomments(quiz_id) {
      var count = 0;
      this.comenzados.forEach((data) => {
        if (quiz_id == data.quiz_id[0]) {
          count = data.__count;
        }
      });
      //console.log("quiz_id", quiz_id, this.comenzados);
      return count;
    },

    async getcommenzadosCount() {
      // var quiz_id = 1;
      // if(quiz_id !== ""){
      await store.dispatch("getcommenzadosCount").then(() => {
        var commenzadosCount = store.getters.getcommenzadosCount;
        //console.log("commenzadosCount::: ", commenzadosCount);
        var count = "0";
        //console.log("count in commenzados", count);
        this.comenzados = commenzadosCount;
        // return count;
      });
      // }
    },

    async getQuizes12() {
      var array_search = [];
      // var searchDropdown = store.getters.getQuizes;

      // //console.log("this.searchDropdown 1", searchDropdown);
      // if (searchDropdown.length == 0) {
      await store.dispatch("getQuizes").then(() => {
        var searchDropdown = store.getters.getQuizes;
        this.searchDropdown = searchDropdown;
        this.searchDropdown.forEach((i) => {
          if (i.partner_id != false && i.partner_id.name != undefined) {
            if (!this.partnerFilter.includes(i.partner_id.name)) {
              this.partnerFilter.push(i.partner_id ? i.partner_id.name : "");
            }
          }
          if (!this.searchDropdownDate.includes(i.create_date)) {
            this.searchDropdownDate.push(i.create_date);
          }
        });
        return;
      });
      // } else {
      //   shuffleArray([searchDropdown]);

      //   this.searchDropdown = searchDropdown;
      //   this.searchDropdown.forEach((i) => {
      //     if (i.partner_id != false && i.partner_id.name != undefined) {
      //       if (!this.partnerFilter.includes(i.partner_id.name)) {
      //         this.partnerFilter.push(i.partner_id ? i.partner_id.name : "");
      //       }
      //     }

      //     if (!this.searchDropdownDate.includes(i.create_date)) {
      //       this.searchDropdownDate.push(i.create_date);
      //     }
      //   });
      //   return;
      // }
    },
    onChangePartnerId() {
      var disp = this.selectedPartnerId;
      this.itemQuiz = this.temp_Quiz;
      var abc = [];
      var data = this.itemQuiz;
      this.searchDropdownName = [];
      this.selectedName = "";
      if (this.selectedPartnerId == null) {
        this.itemQuiz = this.temp_Quiz;
        this.itemQuizPartner = [];
      } else {
        data.forEach((i) => {
          if (i.partner_id.name == disp) {
            abc.push(i);
            if (!this.searchDropdownName.includes(i.slug2)) {
              this.searchDropdownName.push(i.slug2);
            }
          }
        });

        this.itemQuiz = abc;
        this.itemQuizPartner = abc;
      }
    },

    getSortedquiz(sortdata) {
      var itemQuiz = this.itemQuiz;

      var filtered_reviews = [];
      if (sortdata === "createDateAsc") {
        itemQuiz.sort(function (a, b) {
          var b_date = new Date(b.create_date).getTime();
          var a_date = new Date(a.create_date).getTime();
          var c = a_date - b_date;
          // //console.lgo
          return c;
        });

        this.itemQuiz = itemQuiz;
      }
      if (sortdata === "createDateDesc") {
        itemQuiz.sort(function (a, b) {
          var b_date = new Date(b.create_date).getTime();
          var a_date = new Date(a.create_date).getTime();
          var c = b_date - a_date;
          return c;
        });

        this.itemQuiz = itemQuiz;
      }
      if (sortdata === "stat_idAsc") {
        var itemQuiz_sorted = _.sortBy(itemQuiz, "stat_ids.length");

        this.itemQuiz = itemQuiz_sorted;
      }
      if (sortdata === "stat_idDesc") {
        var itemQuiz_sorted = _.sortBy(itemQuiz, "stat_ids.length").reverse();

        this.itemQuiz = itemQuiz_sorted;
      }
    },
    onChangeName() {
      //console.log("this.selectedName", this.selectedName);

      this.locations = [];
      this.row_data = [];
      if (this.selectedName !== null) {
        //console.log("this.selectedName", this.selectedName.id);
        this.getlocationbycity();
      } else {
        this.getlocation();
      }
      // this.selectedCity=[];
      // if(this.selectedName !== null)
      //    this.selectedSurveys.push(this.selectedName.id);

      // this.getQuizesbyQuizid();
    },
    onChangeName12() {
      var disp = this.selectedName;
      // //console.log("this.selectedName ::: ",disp, this.selectedName);
      if (disp == null) {
        this.itemQuiz = this.itemQuizPartner;
      }
      if (!disp == null || !disp == "") {
        var abc = [];
        var data = this.itemQuizPartner;
        data.forEach((i) => {
          if (i.slug2 == disp) {
            abc.push(i);
          }
        });
        // //console.log("abc :::: ", abc.length);
        this.itemQuiz = abc;
      }
      if (!this.selectedPartnerId == null) {
        this.itemQuiz = this.itemQuizPartner;
      }
    },
    onChangeDateSearch() {
      var disp = this.selectedDate;
      // //console.log(disp);
      this.itemQuiz = this.temp_Quiz;
      var abc = [];
      var data = this.itemQuiz;
      data.forEach((i) => {
        if (i.create_date == disp) {
          abc.push(i);
        }
      });
      this.itemQuiz = abc;
    },
    onChangePageitem(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    getRowCount: function () {
      //console.log("this.items ::: ", this.items);
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    selectQuizEdit(item, items) {
      this.quizSelected = item;
      this.modalName = "Editar";
      this.modal = true;
    },
    redirectToCreatePage(item) {
      // this.$router.push({ path: `/createquiz/${item}` });
      this.$router.push({ path: `/createquiz/${item}` });
    },
    redirectToEditPage(item) {
      // this.$router.push({ path: `/createquiz/${item}` });
      this.$router.push({ path: `/editquiz/`, params: { webSite: `${item}` } });
    },
    redirectToanswerTab(item) {
      this.$router.push({ path: `/answer/${item}` });
    },
    selectQuizDelete(item) {
      this.quizSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    selectQuizInfo(item) {
      this.quizSelected = item;
      this.modalName = "Quiz";
      this.modalInfo = true;
    },
    openModal(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modal = true;
    },
    openModalNombre(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalNombre = true;
    },
    openModalDirection(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalDirection = true;
    },
    openModalTelefono(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalTelefono = true;
    },
    openModalCategoriaprincipal(etapa) {
      this.modalName = etapa
      this.modalCategoriaprincipal = true
    },

    openModalCategoriasadicionales(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalCategoriasadicionales = true;
    },

    openModalHorario(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalHorario = true;
    },
    openModalHorarioespecial(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalHorarioespecial = true;
    },
    openModalDescripcion(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalDescripcion = true;
    },
    openModalAnadiratributo(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalAnadiratributo = true;
    },
    openModalAnadirservicio(etapa) {
      //console.log("etapa", etapa);
      this.modalName = etapa;
      this.modalAnadirservicio = true;
    },
    openModalAnadirPost(etapa) {
      this.modalName = etapa;
      this.modalAnadirPost = true
    },
    openModalAnadirImagen(etapa) {
      this.modalName = etapa;
      this.modalAnadirImagen = true

    },

    closeModalCreate() {
      this.modal = false;
    },
    async setNombre() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.updateNombre(loc);
        });
      }
    },
    async updateNombre(e) {
      //console.log("==========> test update nombre", this.row_data, e);
      var payload = {
        location_field: "change_name",
        description: this.store_code,
        location_name: this.nombre,
        row_data: e,
      };
      this.isLoadingnombre = true;
      //console.log("payload", payload);
      await store.dispatch("updateNombre", payload).then(() => {
        var nombre = store.getters.updateNombre;
        //console.log("store nombre update", nombre);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
        this.modalNombre = false;
      });
      this.isLoadingnombre = false;
      return;
    },
    async setDirection() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.updateDirection(loc);
        });
      }
    },
    async updateDirection(e) {
      //console.log("==========> test update direction", this.row_data);
      var payload = {
        location_field: "change_address",
        postal_code: this.postal,
        region_code: this.region,
        administrative_area: this.area_admin,
        locality: this.localidad,
        address: this.direction,
        row_data: e,
      };
      this.isLoadingDirection = true;
      //console.log("payload", payload);
      await store.dispatch("updateDirection", payload).then(() => {
        var nombre = store.getters.updateDirection;
        //console.log("store nombre update", nombre);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
        this.modalDirection = false;
      });
      this.isLoadingDirection = false;
      return;
    },

    async setTelephone() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.updateTelephone(loc);
        });
      }
    },
    async updateTelephone(e) {
      //console.log("==========> test update direction", this.row_data);
      var payload = {
        location_field: "change_phones",
        primary_phone: this.telefono,
        additional_phones: this.telefono_add,
        row_data: e,
      };
      this.isLoadingTelefono = true;
      //console.log("payload", payload);
      await store.dispatch("updateTelephone", payload).then(() => {
        var nombre = store.getters.updateTelephone;
        //console.log("store nombre update", nombre);
        // this.getlocation();
        //console.log("this.selectedName", this.selectedName);
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
        this.modalTelefono = false;
      });
      this.isLoadingTelefono = false;
      return;
    },
   /* async setTelephoneAdditional() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.updateTelephoneAdditional(loc);
        });
      }
    },
    async updateTelephoneAdditional(e) {
      //console.log("==========> test update direction", this.row_data);
      var payload = {
        location_field: "change_additionals_phone",
        additional_phones: this.telefono_add,
        row_data: e,
      };
      this.isLoadingTelefonoadicional = true;
      //console.log("payload", payload);
      await store.dispatch("updateTelephoneAdditional", payload).then(() => {
        var nombre = store.getters.updateTelephoneAdditional;
        //console.log("store nombre update", nombre);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
        this.modalTelefonoadicional = false;
      });
      this.isLoadingTelefonoadicional = false;
      return;
    },*/

    async updateLocationCategories() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.setLocationCategories(loc);
        });
      }
    },
    async setLocationCategories(e) {
      //console.log( "==========> test update direction", this.selected_categories);
      var payload = {
        location_field: "add_category",
        primary_category: this.categoriaPrincipal,
        category_list: [
          {
            category_name: this.selected_categories.name,
            category_id: this.selected_categories.category_id,
          },
        ],
        row_data: e,
      };
      this.isLoadingCategoriaprincipal = true;
      //console.log("payload", payload);
      await store.dispatch("setlocCategory", payload).then(() => {
        var category_updated = store.getters.setlocCategory;
        //console.log("store nombre update", category_updated);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
        this.modalCategoriaprincipal = false;
      });
      this.isLoadingCategoriaprincipal = false;
      return;
    },

    async updatelocationDescription() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.setlocationDescription(loc);
        });
      }
    },
    async setlocationDescription(e) {
      //console.log( "==========> test update direction", this.selected_categories);
      var payload = {
        location_field: "change_description",
        profile_description: this.description,
        row_data: e,
      };
      this.isLoadingDescripcion = true;
      //console.log("payload", payload);
      await store.dispatch("setlocationDescription", payload).then(() => {
        var description_updated = store.getters.setlocationDescription;
        //console.log("store nombre update", description_updated);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
        this.modalDescripcion = false;
      });
      this.isLoadingDescripcion = false;
      return;
    },

    onChangeEventHandler() {
      this.google_attribute_bool = !this.google_attribute_bool;
    },
    async updateGoogleAttribute() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.setGoogleAttribute(loc);
        });
      }
    },
    async setGoogleAttribute(e) {
      // //console.log("==========> test update direction", this.selected_categories);
      var attribute_value = "";
      if (this.possibleAttributeSelected.value_type === "BOOL") {
        attribute_value =
          this.google_attribute_bool === false ? "False" : "True";
      }
      if (this.possibleAttributeSelected.value_type === "REPEATED_ENUM") {
        value_sel = [];
        if (this.possibleAttributeValueSelected.length > 0) {
          this.possibleAttributeValueSelected.forEach((val) => {
            value_sel.push(val.id);
          });
        }

        attribute_value = value_sel; // this.possibleAttributeValueSelected.id
      }
      if (this.possibleAttributeSelected.value_type === "URL") {
        attribute_value = this.google_attribute_url;
      }

      var payload = {
        location_field: "add_atribute",
        google_atribute_ids: this.possibleAttributeSelected.attribute_id, //"<posible attribute location_id field>",
        atribute_type: this.possibleAttributeSelected.value_type, //"<posible attribute value_type field>",
        value: attribute_value, //"<posible attribute values>"
        row_data: e,
      };
      this.isLoadingAnadiratributo = true;
      //console.log("payload", payload);
      await store.dispatch("setGoogleAttribute", payload).then(() => {
        var gAttribute = store.getters.setGoogleAttribute;
        //console.log("store nombre update", gAttribute);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
        this.modalAnadiratributo = false;
      });
      this.isLoadingAnadiratributo = false;
      return;
      // this.modalAnadiratributo=false;
    },

    async getActualLocationAttributes() {
      //console.log("==========> test update direction");
      var payload = {
        row_data: this.row_data,
      };
      //console.log("payload", payload);
      var actualAttribute = [];
      await store.dispatch("getActualLocationAttributes", payload).then(() => {
        actualAttribute = store.getters.getActualLocationAttributes;
        //console.log("store nombre update", actualAttribute);
        this.actualAttribute = actualAttribute;
        // this.modalAnadiratributo=false;
        this.getPossibleLocationAttributes();
      });
      return;
    },
    async getPossibleLocationAttributes() {
      //console.log("==========> test update direction");
      var actual_attribute_id = [];
      this.actualAttribute.forEach((attr) => {
        actual_attribute_id.push(attr.attribute_id);
      });
      //console.log("actual_attribute_id :::: ", actual_attribute_id);

      var payload = {
        actual_attribute_id: actual_attribute_id, //this.actualAttributeSelected.attribute_id,
        row_data: this.row_data,
      };
      //console.log("payload", payload);
      var possibleAttribute = [];

      await store
        .dispatch("getPossibleLocationAttributes", payload)
        .then(() => {
          possibleAttribute = store.getters.getPossibleLocationAttributes;
          //console.log("store nombre update1111", possibleAttribute);
          this.possibleAttribute = possibleAttribute;
          // this.modalAnadiratributo=false;
          // this.getPossibleAttributevalue();
        });
      return;
    },
    async getPossibleAttributevalue() {
      //console.log("==========> test update direction");
      if (this.possibleAttributeSelected.value_type === "REPEATED_ENUM") {
        var payload = {
          atribute_id: this.possibleAttributeSelected.atribute_value_ids,
          row_data: this.row_data,
        };
        //console.log("payload", payload);
        var possibleAttributeValues = [];

        await store.dispatch("getPossibleAttributevalue", payload).then(() => {
          possibleAttributeValues = store.getters.getPossibleAttributevalue;
          //console.log( "store possibleAttributeValues update", possibleAttributeValues);
          this.possibleAttributeValues = possibleAttributeValues;
          // this.modalAnadiratributo=false;
        });
      }
      return;
    },
    async updateLocationSplSchedule() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.setLocationSplSchedule(loc);
        });
      }
    },

    async setLocationSplSchedule(e) {
      //console.log("moment().format('x')", moment().format("x"));
      //console.log( "==========> test update direction", this.hClausura, this.hApertura);
      var payload = {
        location_field: "change_special_hours",
        start_date: this.start_date,
        is_closed: false,
        open_time_special: this.hApertura,
        end_date: this.end_date,
        close_time_special: this.hClausura,
        row_data: e,
      };
      this.isLoadingHorarioespecial = true;
      //console.log("payload", payload);
      await store.dispatch("setLocationSplSchedule", payload).then(() => {
        var updatelocsplschedule = store.getters.setLocationSplSchedule;
        //console.log("store nombre update", updatelocsplschedule);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
      });
      this.isLoadingHorarioespecial = false;
      this.modalHorarioespecial = false;
      return;
    },

    async updateLocationSchedule() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.setLocationSchedule(loc);
        });
      }
    },

    async setLocationSchedule(e) {
      //console.log("moment().format('x')", moment().format("x"));
      //console.log("==========> test update direction");
      var open = [];
      if (this.lunes) {
        if (this.lunes_medio) {
          open.push({
            openDay: "MONDAY",
            openTime: this.hAbre_el_lunes,
            closeTime: this.hCierra_el_lunes_porlamanana,
            closeDay: "MONDAY",
          });

          open.push({
            openDay: "MONDAY",
            openTime: this.hAbre_el_lunes_porlatarde,
            closeTime: this.hCierra_el_lunes,
            closeDay: "MONDAY",
          });
        } else {
          open.push({
            openDay: "MONDAY",
            openTime: this.hAbre_el_lunes,
            closeTime: this.hCierra_el_lunes,
            closeDay: "MONDAY",
          });
        }
      }
      if (this.martes) {
        if (this.martes_medio) {
          open.push({
            openDay: "TUESDAY",
            openTime: this.hAbre_el_martes,
            closeTime: this.hCierra_el_martes_porlamanana,
            closeDay: "TUESDAY",
          });

          open.push({
            openDay: "TUESDAY",
            openTime: this.hAbre_el_martes_porlatarde,
            closeTime: this.hCierra_el_martes,
            closeDay: "TUESDAY",
          });
        } else {
          open.push({
            openDay: "TUESDAY",
            openTime: this.hAbre_el_martes,
            closeTime: this.hCierra_el_martes,
            closeDay: "TUESDAY",
          });
        }
      }
      if (this.miercoles) {
        if (this.miercoles_medio) {
          open.push({
            openDay: "WEDNESDAY",
            openTime: this.hAbre_el_miercoles,
            closeTime: this.hCierra_el_miercoles_porlamanana,
            closeDay: "WEDNESDAY",
          });

          open.push({
            openDay: "WEDNESDAY",
            openTime: this.hAbre_el_miercoles_porlatarde,
            closeTime: this.hCierra_el_miercoles,
            closeDay: "WEDNESDAY",
          });
        } else {
          open.push({
            openDay: "WEDNESDAY",
            openTime: this.hAbre_el_miercoles,
            closeTime: this.hCierra_el_miercoles,
            closeDay: "WEDNESDAY",
          });
        }
      }
      if (this.jueves) {
        if (this.jueves_medio) {
          open.push({
            openDay: "THURSDAY",
            openTime: this.hAbre_el_jueves,
            closeTime: this.hCierra_el_jueves_porlamanana,
            closeDay: "THURSDAY",
          });

          open.push({
            openDay: "THURSDAY",
            openTime: this.hAbre_el_jueves_porlatarde,
            closeTime: this.hCierra_el_jueves,
            closeDay: "THURSDAY",
          });
        } else {
          open.push({
            openDay: "THURSDAY",
            openTime: this.hAbre_el_jueves,
            closeTime: this.hCierra_el_jueves,
            closeDay: "THURSDAY",
          });
        }
      }
      if (this.viernes) {
        if (this.viernes_medio) {
          open.push({
            openDay: "FRIDAY",
            openTime: this.hAbre_el_viernes,
            closeTime: this.hCierra_el_viernes_porlamanana,
            closeDay: "FRIDAY",
          });

          open.push({
            openDay: "FRIDAY",
            openTime: this.hAbre_el_viernes_porlatarde,
            closeTime: this.hCierra_el_viernes,
            closeDay: "FRIDAY",
          });
        } else {
          open.push({
            openDay: "FRIDAY",
            openTime: this.hAbre_el_viernes,
            closeTime: this.hCierra_el_viernes,
            closeDay: "FRIDAY",
          });
        }
      }
      if (this.sabado) {
        if (this.sabado_medio) {
          open.push({
            openDay: "SATURDAY",
            openTime: this.hAbre_el_sabado,
            closeTime: this.hCierra_el_sabado_porlamanana,
            closeDay: "SATURDAY",
          });

          open.push({
            openDay: "SATURDAY",
            openTime: this.hAbre_el_sabado_porlatarde,
            closeTime: this.hCierra_el_sabado,
            closeDay: "SATURDAY",
          });
        } else {
          open.push({
            openDay: "SATURDAY",
            openTime: this.hAbre_el_sabado,
            closeTime: this.hCierra_el_sabado,
            closeDay: "SATURDAY",
          });
        }
      }
      if (this.domingo == true) {
        if (this.sabado_medio) {
          open.push({
            openDay: "SUNDAY",
            openTime: this.hAbre_el_domingo,
            closeTime: this.hCierra_el_domingo_porlamanana,
            closeDay: "SUNDAY",
          });

          open.push({
            openDay: "SUNDAY",
            openTime: this.hAbre_el_domingo_porlatarde,
            closeTime: this.hCierra_el_domingo,
            closeDay: "SUNDAY",
          });
        } else {
          open.push({
            openDay: "SUNDAY",
            openTime: this.hAbre_el_domingo,
            closeTime: this.hCierra_el_domingo,
            closeDay: "SUNDAY",
          });
        }
      }
      //console.log("open ::: ", open);
      var payload = {
        location_field: "change_hours",
        its_open: open,
        row_data: e, //this.row_data
      };
      this.isLoadingHorario = true;
      //console.log("payload", payload);
      await store.dispatch("setLocationSchedule", payload).then(() => {
        var updatelocschedule = store.getters.setLocationSchedule;
        //console.log("store nombre update", updatelocschedule);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
      });
      this.isLoadingHorario = false;
      this.modalHorario = false;
      return;
    },

    async setLocationService() {
      var locations = this.row_data;
      //console.log("locations selected ::::: ", locations);
      if (locations.length > 0) {
        locations.forEach((loc) => {
          this.addLocationService(loc);
        });
      }
    },

    async addLocationService(e) {
      //console.log("==========> test update direction");
      var google_services_ids = "";

      var payload = {
        location_field: "add_service",
        google_services_ids: this.selected_google_services_ids.id,
        is_money: this.tine_precio,
        service_type_free_form: this.tipo_de_servicio,
        currency_code: this.moneda,
        units: this.precio,
        row_data: e,
      };
      this.isLoadingAnadirservicio = true;
      //console.log("payload", payload);
      await store.dispatch("addLocationService", payload).then(() => {
        var updatelocationService = store.getters.addLocationService;
        //console.log("store updatelocationService", updatelocationService);
        // this.getlocation();
        if (
          this.selectedName !== null &&
          this.selectedName !== "" &&
          this.selectedName !== undefined
        ) {
          this.getlocationbycity();
        } else {
          this.getlocation();
        }
      });
      this.isLoadingAnadirservicio = false;
      this.modalAnadirservicio = false;
      return;
    },

    async getlocationCategories() {
      //console.log("==========> test update direction", this.row_data);
      var payload = {
        row_data: this.row_data,
      };
      await store.dispatch("getlocationCategories", payload).then(() => {
        var location_categories = store.getters.getlocationCategories;
        //console.log("store location_categories", location_categories);
        // this.getlocation();
        this.location_categories = location_categories;
        // this.modalTelefono=false;
        var loccategories = [];
        if (location_categories.length > 0) {
          location_categories.forEach((cat) => {
            loccategories.push(cat.category_id);
          });
        }
        //console.log("loccategories :::: ", loccategories);
        this.loccategories = loccategories;
      });
      await this.getpossibleCat();
      return;
    },
    async getpossibleCat() {
      await this.getpossibleCategories();
    },

    async getpossibleCategories() {
      //console.log("==========> test update direction");
      var payload = {
        category_id: this.loccategories, //this.selected_loc_categories.category_id
      };
      //console.log("payload", payload);
      var possible_categories = [];
      await store.dispatch("getpossibleCategories", payload).then(() => {
        possible_categories = store.getters.getpossibleCategories;
        //console.log("store possible_categories", possible_categories);
        this.possible_categories = possible_categories;
        // this.modalAnadiratributo=false;
        var possiblecat = [];
        if (possible_categories.length > 0) {
          possible_categories.forEach((pcat) => {
            possiblecat.push(pcat.id);
          });
        }
        this.possiblecat = possiblecat;
      });
      await this.getpService();

      return;
    },

    async getpService() {
      await this.getpossibleServices();
    },

    async getpossibleServices() {
      //console.log("==========> test update direction");
      var possible_cat = this.possiblecat;
      var payload = {
        google_category_ids: possible_cat, //this.selected_possible_categories.id
      };
      //console.log("payload", payload);
      var possible_services = [];
      await store.dispatch("getpossibleServices", payload).then(() => {
        possible_services = store.getters.getpossibleServices;
        //console.log("store possible_services", possible_services);
        this.possible_services = possible_services;
        if (possible_services.length == 0) {
          this.showtipodeservecio = true;
        } else {
          this.showtipodeservecio = false;
        }
        // this.modalAnadiratributo=false;
      });
      return;
    },

    publicarFtp(id) {
      store
        .dispatch("getBotonActionResponse", {
          model: "apache.quiz",
          method: "public_quiz",
          id,
        })
        .then(() => {
          var boton_action_response = store.getters.getBotonActionResponse;
          if (boton_action_response.target === "_blank") {
            window.open(Constant.api_path + boton_action_response.url);
          } else {
            this.sendFtp = true;
            //window.location(Constant.api_path+boton_action_response.url)
          }
        });
    },
    quizPreview(id) {
      store
        .dispatch("getBotonActionResponse", {
          model: "apache.quiz",
          method: "quiz_preview",
          id,
        })
        .then(() => {
          var boton_action_response = store.getters.getBotonActionResponse;
          //console.log( "Constant.api_path + boton_action_response.url ::: ", Constant.api_path, boton_action_response.url, boton_action_response.target);

          if (boton_action_response.target === "_blank") {
            window.open(Constant.api_path + boton_action_response.url);
          } else {
            window.location(Constant.api_path + boton_action_response.url);
          }
        });
      this.confirmar = false;
    },
    eliminar() {
      //console.log("this.quizSelected.id ::: ", this.quizSelected);
      setTimeout(() => {
        store.dispatch("deleteQuizUtility", this.quizSelected.id);
      }, 400);
      store.dispatch("deleteQuiz", this.quizSelected.id);
      this.confirmar = false;
    },
    changeView(type) {
      this.type_show = type;
    },
  },
  watch: {
  
    selectedPartnerId: function (partnerSelected) {
      var partner_ids = [];
      this.locations = [];
      this.row_data = [];

      //console.log("partner_ids::::", partnerSelected);
      if (partnerSelected !== null) {
        partner_ids.push(partnerSelected.id);
      }
      // partnerSelected.forEach((partner) => {
      //     partner_ids.push(partner.id);
      // });
      this.quizSelected = [];
      //console.log("partner_ids::::", partnerSelected, partner_ids);

      if (partner_ids.length > 0) {
        // partner_ids = partner_ids;
        this.partner_ids = partner_ids;
        // this.getQuizes();
        this.getlocation();

        // this.getcommenzadosCount();
        // this.surveys_temp=surveys;
      } else {
        // this.partners=[];
        // this.partner_ids=[];
        this.surveys = [];
        this.quiz_ids = [];
        this.surveys_temp = [];
        this.locations = [];
        this.locations1 = [[]];
        this.locationsArray = [];
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}

.modal-body-small {
  overflow-y: auto;
  height: 30vu;
  padding-top: 100px !important;
}

.modal-contenedor {
  top: 50px;
}
.box {
  /* height: 175px; */
  /* width: 200px; */
  padding-left: 10px;
  padding-top: 80px;
  padding-bottom: 80px;
  background-image: url(../../../public/img/Apache_logo.png);
  background-size: cover;
  background-color: "#ced2d8";
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  /* color: blue; */
}
.addonButton {
  margin: 5px;
}
</style>
